<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增白名单项' : '修改白名单项'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="UID集合">
          <el-input
            type="textarea"
            rows="15"
            v-model="form.uidList"
            placeholder="可放多个UID，每行一个"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("../../util");
export default {
  data() {
    return {
      visible: true,
      form: {
        uidList: "", // uid集合
      },
      rules: {
        uidList: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.uidList = this.value.oldData.uidList;
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addWhiteListEntries();
      } else {
        this.updateWhiteListEntry();
      }
    },

    /**
     * 新增一批白名单项
     */
    addWhiteListEntries() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let parseResult = this.parseUidList();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        let uidList = parseResult.list;

        let requestBody = {
          uidList: [],
        };

        for (let e of uidList) {
          requestBody.uidList.push({
            uid: e.toString()
          })
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/addCheckWhiteList`,
            requestBody,
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: "添加失败",
            type: "error",
          });
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改白名单项
     */
    updateWhiteListEntry() {
      return;
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },

    /**
     * 解析uid集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseUidList() {
      let list = [];

      let uidListStr = this.form.uidList.trim();
      if (uidListStr.length > 0) {
        let arr = uidListStr.split(/\s+/);
        for (let e of arr) {
          let uid = Number(e);
          if (isNaN(uid) || uid != parseInt(uid)) {
            return {
              list: [],
              err: "UID格式错误",
            };
          }

          if (uid <= 0) {
            return {
              list: [],
              err: "UID必须是正整数",
            };
          }

          list.push(uid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入UID",
        };
      }

      return {
        list: list,
      };
    },
  },
};
</script>